"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetWheel = void 0;
var react_1 = require("react");
var user_1 = require("../user");
var useGetAuthWheel_1 = require("./useGetAuthWheel");
var useGetUnAuthWheel_1 = require("./useGetUnAuthWheel");
var useGetWheel = function () {
    var isAuth = (0, user_1.useIsAuthorized)();
    var _a = (0, useGetAuthWheel_1.useGetAuthWheel)(), authWheelData = _a.data, authWheelError = _a.error, authWheelIsLoading = _a.isLoading, authWheelIsValidating = _a.isValidating;
    var _b = (0, useGetUnAuthWheel_1.useGetUnAuthWheel)(), unAuthWheelData = _b.data, unAuthWheelError = _b.error, unAuthWheelIsLoading = _b.isLoading, unAuthWheelIsValidating = _b.isValidating;
    return (0, react_1.useMemo)(function () { return ({
        data: isAuth ? authWheelData : unAuthWheelData,
        isLoading: isAuth ? authWheelIsLoading : unAuthWheelIsLoading,
        isValidating: isAuth ? authWheelIsValidating : unAuthWheelIsValidating,
        error: isAuth ? authWheelError : unAuthWheelError,
    }); }, [
        isAuth,
        authWheelIsLoading,
        authWheelData,
        authWheelError,
        authWheelIsValidating,
        unAuthWheelIsLoading,
        unAuthWheelData,
        unAuthWheelError,
        unAuthWheelIsValidating,
    ]);
};
exports.useGetWheel = useGetWheel;
